import { Box, Divider, Typography } from '@mui/material';
import { IOperation } from 'Models/Operation';
import { useEffect, useState } from 'react';
import { useIntl } from 'react-intl';
import { useSelector } from 'react-redux';
import { useGetCountryByCodeQuery } from 'redux/api/countryApi';

export const OperationDetails = ({ operation }: { operation: IOperation }) => {
    const { formatMessage, locale } = useIntl();
    const [nationality, setNationality] = useState(operation.nationality||'');
    
    const documentTypeName = useSelector((state: any) => state.operationState?.documentTypeName);
    const { data: countryFound, refetch, isFetching, isSuccess:isCountrySucces, error:countryError } = useGetCountryByCodeQuery(
            { code: operation?.nationality, language: locale}
        );
    useEffect(() => {
            if (isCountrySucces && countryFound) {
                setNationality(countryFound);
            }
        }, [isCountrySucces, countryFound]);
    
    return (
        <Box
            sx={{
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                alignItems: 'flex-start',
                textAlign: 'left',
                margin: '0 auto',
                width: '70%',
                "@media (max-width: 600px)": {
                    width: '90%',
                },
                marginTop: '20px',
            }}
        >
            <Box sx={{ marginBottom: '8px', borderBottom: '1px solid #ccc', paddingBottom: '8px', width: '100%' }}>
            {formatMessage({ id: "opeartion.details.name" })}<strong>{operation.clientName}</strong>
            </Box>
            <Box sx={{ marginBottom: '8px', borderBottom: '1px solid #ccc', paddingBottom: '8px', width: '100%' }}>
            {formatMessage({ id: "opeartion.details.operation" })}<strong>{operation.id}</strong>
            </Box>
            <Box sx={{ marginBottom: '8px', borderBottom: '1px solid #ccc', paddingBottom: '8px', width: '100%' }}>
            {formatMessage({ id: "opeartion.details.date" })}<strong> {new Date(operation.operationDate).toLocaleDateString()}</strong>
            </Box>
            <Box sx={{ marginBottom: '8px', borderBottom: '1px solid #ccc', paddingBottom: '8px', width: '100%' }}>
            {formatMessage({ id: "opeartion.details.ammount" })}<strong> <span style={{ fontWeight: 'bold' }}>{operation.amount}€</span></strong>
            </Box>
            <Box sx={{ marginBottom: '8px', borderBottom: '1px solid #ccc', paddingBottom: '8px', width: '100%' }}>
            {formatMessage({ id: "opeartion.details.document" })}<strong>{operation.documentNumber}</strong>
            </Box>
            <Box sx={{ marginBottom: '8px', borderBottom: '1px solid #ccc', paddingBottom: '8px', width: '100%' }}>
            {formatMessage({ id: "opeartion.details.nationality" })}<strong>{nationality}</strong>
            </Box>
            {documentTypeName === "DNI" && (
                <>
                    <Box sx={{ marginBottom: '8px', borderBottom: '1px solid #ccc', paddingBottom: '8px', width: '100%' }}>
                    {formatMessage({ id: "opeartion.details.address" })}<strong>{operation.clientAddress}</strong>
                    </Box>
                    <Box sx={{ marginBottom: '8px', borderBottom: '1px solid #ccc', paddingBottom: '8px', width: '100%' }}>
                    {formatMessage({ id: "opeartion.details.province" })}<strong>{operation.province}</strong>
                    </Box>
                </>
            )}
            {documentTypeName === "UE ID Card" && (
                <>
                    <Box sx={{ marginBottom: '8px', borderBottom: '1px solid #ccc', paddingBottom: '8px', width: '100%' }}>
                    {formatMessage({ id: "opeartion.details.address" })}<strong>{operation.clientAddress}</strong>
                    </Box>
                </>
            )}
        </Box>

    );
}

